// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"101":"90897487","115":"756cab21","239":"c5f68727","388":"c14685e5","457":"7c5a3420","551":"e48e2e00","640":"e06e3ab1","732":"fda73a07","851":"59466e1d","977":"01378288"}[chunkId] + ".chunk.js";
};